import calcRandomNumberWithMax from "./calc_random_number_with_max";

export const determineAccountNbr = (accountList) => {
    let accountNbrArr = [];
    let accountNbr = "";
    for (let i=0; i<accountList.length; i++){
        accountNbr = accountList[i]._id;
        accountNbrArr.push(accountNbr);
    }
    let accountFound = true;
    // ensure the account number is unique
    while (accountFound === true){
        accountNbr = calcRandomNumberWithMax(9,false, 6);
        accountFound = accountNbrArr.includes(accountNbr);
    };
    return accountNbr;
}
export default determineAccountNbr;